import type { CSSProperties } from 'react';

import { X } from '@phosphor-icons/react';
import classNames from 'classnames';

import SimpleModal from '../ui/SimpleModal';

import { cn } from '../utils/cn';

import { loginModalContentContainer, loginModalDialogContent } from './LoginModal.css';
import type { LoginModalElementProps } from './LoginModal.type';

export function LoginModalElement(props: LoginModalElementProps) {
  const { element, children, isOpen = false, onOpenChange, isPreviewing = false } = props;
  const {
    gap,
    width,
    maxWidth,
    padding,
    backgroundColor,
    borderRadius,
    borderWidth,
    borderColor,
    borderStyle,
    modalOverlayBackgroundColor,
    modalCloseButtonColor = 'inherit',
    modalCloseButtonPlacementTop,
    modalCloseButtonPlacementRight,
  } = element.attrs || {};

  const generatedStyle = {
    '--overlay-background-color': modalOverlayBackgroundColor,
    '--modal-close-button-color': modalCloseButtonColor,
    '--modal-close-button-placement-top': modalCloseButtonPlacementTop || '24px',
    '--modal-close-button-placement-right': modalCloseButtonPlacementRight || '24px',
  } as CSSProperties;

  const renderedElement = (
    <div
      className={classNames(loginModalContentContainer, 'flex flex-col h-auto')}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
          backgroundColor,
          padding,
          borderStyle,
          borderWidth,
          borderRadius,
          borderColor,
          gap,
          '--padding': padding,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );

  if (isPreviewing) {
    return (
      <div className="w-full h-auto min-h-[600px] flex items-center justify-center relative" style={generatedStyle}>
        <div className="absolute top-0 left-0 w-full h-full bg-[--overlay-background-color]">&nbsp;</div>
        <div className="z-10 relative">
          {renderedElement}
          <button
            type="button"
            className={cn(
              'absolute right-[--modal-close-button-placement-right] top-[--modal-close-button-placement-top] rounded-sm opacity-70',
              'hover:opacity-100 transition-opacity',
              'focus:outline-none focus:ring-2 focus:ring-offset-2',
              'text-[--modal-close-button-color]',
            )}
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <SimpleModal isOpen={isOpen} onClose={onOpenChange} style={generatedStyle} className="shadow-lg">
      <div className={classNames(loginModalDialogContent)}>{renderedElement}</div>
    </SimpleModal>
  );
}
